<template>
    <!-- <div class="wrapperCard"> -->
        <div class="card-blank">
           <slot></slot>
        </div>
    <!-- </div> -->
</template>

<style lang="scss" scoped>
// .wrapperCard{
    .card-blank{
        width: 500px;
        height: fit-content;
        background-color: $white;
        position: absolute;
        top: 0;
        bottom: 0; /* Aligns Vertically */
        left: 0;
        right: 0; /* Aligns Horizontally */
        margin: auto;
        border-radius: 10px;
        padding: 2rem 3rem;
        @media only screen and (max-width: 600px) {
            // background-color: transparent !important;
            width: 90%;
            padding: 2rem 1rem;
            max-width: 400px;
        }
        img{
            width: 130px;
            margin: 0 auto;
             @media only screen and (max-width: 600px) {
                 margin: 3rem auto;
             }
        }
        .small{
             @media only screen and (max-width: 600px) {
                 width: 80px;
             }
        }
    }
// }
</style>
